export default __webpack_public_path__ + "static/lauren_groff-8c0f895f95817e1977b2510c5f9eae59.jpg";